export enum OrderRemakeType {
  LOST_PACKAGE = "LOST_PACKAGE",
  REMAKE_ORDER = "REMAKE_ORDER",
}
